/* eslint-disable */

import React from "react";
import Chart from "chart.js/auto";
import { CategoryScale } from "chart.js";
import { Line } from "react-chartjs-2";
import type { ChartData, ChartOptions } from "chart.js";

Chart.register(CategoryScale);
interface IProps {
  data: ChartData<"line">;
  options: ChartOptions<"line">;
}
const LineCharts = ({ data, options }: IProps) => {
  return (
    <div className="line-chart">
      <Line data={data} options={options} />
    </div>
  );
};

export default LineCharts;
